import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { NewOemStore, CreateOemDto } from '../../../../../stores/configuration/machinery/oems-store';
import { nameof } from '../../../../../utils/object';

interface NewOemViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newOem?: NewOemStore;
}

// tslint:disable-next-line:no-empty-interface
interface NewOemViewState {}

@connect(['newOem', NewOemStore])
class NewOemView extends React.Component<NewOemViewProps, NewOemViewState> {
  private get newOemStore() {
    return this.props.newOem;
  }

  constructor(props: NewOemViewProps) {
    super(props);
    this.newOemStore.createNew({
      name: ''
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewOemViewProps) {
    if (this.newOemStore.state.result && this.newOemStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.newOemStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newOemStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.newOemStore.change({ ...this.newOemStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newOemStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New OEM')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newOemStore.state.result && !this.newOemStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newOemStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newOemStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    label={t('OEM')}
                    placeholder={t('Name')}
                    value={this.newOemStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateOemDto>('name'), value)}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewOemView);
